import {Attribute} from '../../../components/ObjectAttribute';
import {Json} from '../../../components/JsonObjectCard';
import {RequestExample} from '../../../components/RequestExampleCard';
import {RequestDefinitionData} from '../../../components/RequestDefinition';

const createUomRequest: RequestExample = {
    title: {
        verb: 'POST',
        endpointUrl: '/api/uoms',
    },
    curl:
        `curl --location \\
--request POST '<YOUR SERVER>/api/uoms' \\
--header 'Content-Type: application/json' \\
--header 'Authorization: Bearer <TOKEN>' \\
--data-raw '<UOM JSON>'
`,
};

const createUomResponse: Json = {
    title: 'RESPONSE',
    json: {
        "id": 25,
        "name": "box",
        "abbreviation": "bx",
        "description": "A cardboard container",
        "type": "Count",
        "active": true,
        "integral": false,
        "readOnly": false,
        "conversions": [
            {
                "id": 37,
                "description": "1 box = 15.0 Each",
                "targetUom": {
                    "id": 1,
                    "name": "Each",
                    "abbreviation": "ea"
                },
                "divisor": "15",
                "multiplier": "1"
            }
        ]
    },
};

const createUomAttributes: Attribute[] = [
    {
        name: 'name',
        type: 'string',
        description: 'The UOM name.',
    },
    {
        name: 'abbreviation',
        type: 'string',
        description: 'The UOM abbreviation.',
    },
    {
        name: 'description',
        type: 'string',
        description: 'The UOM description.',
    },
    {
        name: 'type',
        type: 'string: \'Area\' | \'Count\' | \'Length\' | \'Time\' | \'Volume\' | \'Weight\'',
        description: 'The basic type of the UOM.',
    },
    {
        name: 'active',
        type: 'boolean',
        optional: true,
        description: 'The active status of the UOM.',
    },
    {
        name: 'readOnly',
        type: 'boolean',
        optional: true,
        description: 'Indicates if the UOM is read-only.',
    },
    {
        name: 'conversions',
        type: 'list',
        optional: true,
        description: 'A list of the UOM conversions.',
        children: [
            {
                name: 'targetUom',
                type: 'reference object',
                description: 'The resulting UOM of the conversion.',
                children: [
                    {
                        name: 'id',
                        type: 'integer',
                        description: 'The unique identification number.',
                    },
                ]
            },
            {
                name: 'divisor',
                type: 'quantity',
                description: 'Divide the quantity by the divisor to convert to the target UOM.',
            },
            {
                name: 'multiplier',
                type: 'quantity',
                description: 'Multiply the quantity by the multiplier to convert to the target UOM.',
            },
        ]
    }
];

const data: RequestDefinitionData = {
    id: 'create-uom',
    title: 'Create a unit of measure',
    description: 'Creates a unit of measure.',
    endpoint: {
        verb: 'POST',
        path: '/uoms',
        tooltip: 'Create a unit of measure',
    },
    attributes: createUomAttributes,
    requestObject: createUomRequest,
    responseObject: createUomResponse,
};

export default data;
